export const commonSeaFishSpecies = [
    'Unknown',
    'Angel Shark',
    'Bass',
    'Black Bream',
    'Brill',
    'Bull Huss',
    'Coalfish',
    'Cod',
    'Conger Eel',
    'Dab',
    'Dogfish',
    'Flounder',
    'Garfish',
    'Greater Forkbeard',
    'Gurnard (Tub)',
    'Gurnard (Red)',
    'Gurnard (Grey)',
    'Haddock',
    'Hake',
    'Halibut',
    'Herring',
    'Ling',
    'Mackerel',
    'Megrim',
    'Monkfish',
    'Mullet (Red)',
    'Mullet (Golden Grey)',
    'Mullet (Thick Lipped Grey)',
    'Mullet (Thin Lipped Grey)',
    'Plaice',
    'Pollock',
    'Poor Cod',
    'Porbeagle Shark',
    'Pouting',
    'Ray (Spotted)',
    'Ray (Blonde)',
    'Ray (Thornback)',
    'Ray (Small Eyed)',
    'Rockling (Three Bearded)',
    'Rockling (Four Bearded)',
    'Rockling (Five Bearded)',
    'Rockling (Shore)',
    'Greater Sandeel',
    'Scad',
    'Silver Eel',
    'Skate (Common)',
    'Smoothhound',
    'Sole (Dover)',
    'Sole (Lemon)',
    'Spurdog',
    'Sunfish',
    'Tope',
    'Triggerfish',
    'Turbot',
    'Weever (Lesser)',
    'Weever (Greater)',
    'Whiting',
    'Wrasse (Ballan)',
    'Wrasse (Cuckoo)'
  ].sort();
  
  export const commonCoarseFishSpecies = [
    'Barbel',
    'Bitterling',
    'Bleak',
    'Bream (Common Bronze)',
    'Bream (Silver)',
    'Bullhead',
    'Carp (Mirror)',
    'Carp (Crucian)',
    'Carp (Grass)',
    'Catfish (Bullhead)',
    'Catfish (Wels)',
    'Chub',
    'Dace',
    'Eel',
    'Goldfish (Brown)',
    'Gudgeon',
    'Ide',
    'Orfe',
    'Minnow',
    'Perch',
    'Pike',
    'Pumpkinseed',
    'Roach',
    'Rudd',
    'Ruffe',
    'Schelly',
    'Stickleback (3-spined)',
    'Stone Loach',
    'Tench',
    'Walleye',
    'Zander'
  ].sort();